export default __webpack_public_path__ + "locales/pl/Webhooks.json?hash=67388f415ebc650d6f50903c678be907";